module.exports = __webpack_public_path__ + "assets/img/dishes2.5cae4e55.png";